import Vue from 'vue/dist/vue.esm'
import ProjectCartForm from 'components/storefront/project-cart-form.vue'

export default function buildProjectApp(element) {
  new Vue({
    el: element,
    components: {
      ProjectCartForm
    }
  })
}
